import React, { memo } from 'react';
import { FormInput, FormCheckbox } from '@core/components/form';
import { WistiaEmbedVideoWidgetForm } from './WistiaEmbedVideoBlock';

export interface EmbedBlockSettingsProps {
  form: WistiaEmbedVideoWidgetForm;
}

export const WistiaEmbedVideoBlockSettings = memo((props: EmbedBlockSettingsProps) => {
  const { form } = props;

  return (
    <div>
      <FormInput control={form.controls.wistiaVideoId} />
      <FormCheckbox control={form.controls.fullWdith} />
    </div>
  );
});
